import { selectIsAddressEditingExpired } from '../../../../../../shared/selectors/offer/geo';
import template from './building-address.jade';

export default angular.module('cian.addForm.buildingAddress', []).directive('cianAfAddressBuildingAddress', () => ({
  scope: {},
  bindToController: {
    ad: '=',
    form: '=',
  },
  controller: [
    '$scope',
    'deviceService',
    'store',
    function ($scope, deviceService, store) {
      const state = store.getState();
      $scope.isAddressEditingExpired = selectIsAddressEditingExpired(state);

      this.isMobile = deviceService.isMobile;

      $scope.$on('addform.clear', () => {
        this.ad.geo.buildingAddress = '';
      });
    },
  ],
  controllerAs: 'buildingAddress',
  template,
})).name;
